export default __webpack_public_path__ + "static/media/IMG_4994-min.30c514b8.JPG";